// Refresh visible and previously loaded upload branches without replacing their
// expansion/selection state. Build offscreen so a failed request retains the tree.
export const refreshLoadedUploadTree = async (tree, keys, fetchChildren) => {
    const loaded = new Set(keys);
    const visit = async nodes => Promise.all(nodes.map(async node => {
        if (node.isLeaf || (!node.children && !loaded.has(node.key))) return node;
        const previous = new Map((node.children || []).map(child => [child.key, child]));
        const fresh = await fetchChildren(node);
        const children = fresh.map(child => ({...child, ...(previous.get(child.key)?.children &&
            {children: previous.get(child.key).children})}));
        return {...node, children: await visit(children)};
    }));
    return visit(tree);
};
